import React from 'react';
import { EditableText, NonIdealState } from '@blueprintjs/core';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { useTorgaContext } from '../TorgaContext';
import { actionEquipmentUpdate } from './actions';
import { urlToActivityID } from '../TorgaRouter';

export default function Equipment() {
  const { state, dispatch, dispatchAction } = useTorgaContext();
  const { id } = useParams();
  const equipment = state.equipments.byID[id];

  if (!id) {
    return <NonIdealState icon="build" title="Select an equipment" />;
  }

  if (!equipment) {
    return <div>Loading...</div>;
  }

  const linkedActivityIDs = state.activities.idsBy.equipmentID[id] || [];

  const handleChange = (field, value) => {
    dispatch({ type: 'EQUIPMENT_CHANGE', payload: { id, field, value } });
  };

  const handleConfirm = (field, value) => {
    dispatchAction(actionEquipmentUpdate(id, field, value));
  };

  return (
    <div>
      <h1>
        E{equipment.id} -{' '}
        <EditableText
          placeholder="Equipment Name"
          value={equipment.name}
          onChange={(value) => handleChange('name', value)}
          onConfirm={(value) => handleConfirm('name', value)}
          selectAllOnFocus
        />
      </h1>

      <table>
        <tbody>
          <tr>
            <td>Category</td>
            <td>
              <EditableText
                value={equipment.catego || ''}
                onChange={(value) => handleChange('catego', value)}
                onConfirm={(value) => handleConfirm('catego', value)}
              />
            </td>
          </tr>
          <tr>
            <td>Type</td>
            <td>
              <EditableText
                value={equipment.type || ''}
                onChange={(value) => handleChange('type', value)}
                onConfirm={(value) => handleConfirm('type', value)}
              />
            </td>
          </tr>
          <tr>
            <td>Brand</td>
            <td>
              <EditableText
                value={equipment.brand || ''}
                onChange={(value) => handleChange('brand', value)}
                onConfirm={(value) => handleConfirm('brand', value)}
              />
            </td>
          </tr>
          <tr>
            <td>Model</td>
            <td>
              <EditableText
                value={equipment.model || ''}
                onChange={(value) => handleChange('model', value)}
                onConfirm={(value) => handleConfirm('model', value)}
              />
            </td>
          </tr>
          <tr>
            <td>Location</td>
            <td>
              <EditableText
                value={equipment.location || ''}
                onChange={(value) => handleChange('location', value)}
                onConfirm={(value) => handleConfirm('location', value)}
              />
            </td>
          </tr>
        </tbody>
      </table>

      <hr />
      <h3>Linked activities</h3>
      {linkedActivityIDs.length === 0 ? (
        <div>No linked activity.</div>
      ) : (
        <ul>
          {linkedActivityIDs.map((activityID) => {
            const activity = state.activities.byID[activityID];
            return (
              <li key={activityID}>
                <Link to={urlToActivityID(activityID)}>
                  A{activityID} {activity?.name ? `- ${activity.name}` : ''}
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
